import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { Bell, User, LogOut, Menu, Moon, Sun } from 'lucide-react';

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { isDark, toggleTheme } = useTheme();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const { office, isTrialExpiringSoon, getTrialRemainingDays } = useAuth();
  const showTrialBanner = isTrialExpiringSoon ? isTrialExpiringSoon() : false;
  const trialDays = getTrialRemainingDays ? getTrialRemainingDays() : 0;

  return (
    <>
      <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 h-16 fixed top-0 right-0 left-0 lg:left-64 z-10 transition-colors flex items-center">
        <div className="w-full px-4 sm:px-6 flex items-center justify-between">
          {/* Mobile Menu Button */}
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
          >
            <Menu size={24} className="text-gray-600 dark:text-gray-300" />
          </button>

          {/* Welcome Text */}
          <div className="flex-1 lg:flex-initial flex items-center gap-3">
            <h2 className="text-base sm:text-lg font-semibold text-gray-800 dark:text-gray-100 truncate">
              Hoş Geldiniz, {user?.name}
            </h2>
            {office && (
              <span className="hidden md:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-300">
                {office.name}
              </span>
            )}
          </div>

          {/* Right Side Actions */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Dark Mode Toggle *
          <button
            onClick={toggleTheme}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-all transform hover:scale-110"
            title={isDark ? 'Açık Tema' : 'Koyu Tema'}
          >
            {isDark ? (
              <Sun size={20} className="text-yellow-500" />
            ) : (
              <Moon size={20} className="text-gray-600" />
            )}
          </button>*/}

            {/* Notifications */}
            <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md relative transition-colors">
              <Bell size={20} className="text-gray-600 dark:text-gray-300" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>

            {/* User Info - Hidden on mobile */}
            <div
              onClick={() => navigate('/profile')}
              className="hidden sm:flex items-center gap-2 pl-4 border-l border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 p-2 rounded-lg transition-colors"
              title="Profilime Git"
            >
              <div className="w-8 h-8 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                <User size={18} className="text-primary-600 dark:text-primary-400" />
              </div>
              <div className="hidden md:block text-sm">
                <p className="font-medium text-gray-800 dark:text-gray-100">{user?.name}</p>
                <p className="text-gray-500 dark:text-gray-400 text-xs items-center gap-1 flex">
                  <span>{user?.is_manager ? 'Yönetici' : 'Personel'} - {user?.department?.name}</span>
                </p>
              </div>
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="p-2 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md text-red-600 dark:text-red-400 transition-colors"
              title="Çıkış Yap"
            >
              <LogOut size={20} />
            </button>
          </div>
        </div>
      </header>

      {showTrialBanner && (
        <div className="fixed top-16 right-0 left-0 lg:left-64 z-10 bg-yellow-100 border-b border-yellow-200 text-yellow-800 px-4 py-2 text-center text-sm font-medium">
          Deneme sürenizin bitmesine <strong>{trialDays} gün</strong> kaldı. Kesintisiz kullanım için aboneliğinizi yenileyin.
        </div>
      )}
    </>
  );
};

export default Header;
